
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 363 242"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#338AF3","d":"M0 0h363v242H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M57 96.9L14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M75.6 40.6l11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"}}),_c('g',{attrs:{"fill":"#FFDA44"}},[_c('path',{attrs:{"d":"M0 152.2h363v15.7H0zM0 183.6h363v15.7H0z"}})])])
          )
        }
      }
    